export const createCohortData = function (
  arrData,
  { startDate, endDate },
  average
) {
  const showPeriod = 24;
  const cohortTable = [];

  let allDates = Object.keys(arrData);
  if (startDate || endDate) {
    const from = dateFormat(startDate);
    const to = dateFormat(endDate);

    if (check(allDates, to, from)) {
      return cohortTable;
    }

    const indF = allDates.indexOf(from) !== -1 ? allDates.indexOf(from) : 0;
    const indT =
      allDates.indexOf(to) !== -1 ? allDates.indexOf(to) + 1 : allDates.length;
    allDates = allDates.slice(indF, indT);
  }

  if (allDates.length > showPeriod) {
    const cut = allDates.length - showPeriod;
    allDates = allDates.slice(cut);
  }

  let initSum = 0;
  let currSum = 0;

  allDates.map(date => {
    const dateData = arrData[date];
    const tempArr = [];

    initSum += dateData.initialNumOfCustomers;
    currSum += dateData.currentNumOfCustomers;

    dateData.data.map(val => {
      tempArr.push(
        val
          ? val
          : {
              arrPercent: 0,
              totalArr: 0
            }
      );
      return true;
    });

    cohortTable.push([
      date,
      dateData.initialNumOfCustomers,
      dateData.currentNumOfCustomers,
      ...tempArr
    ]);
    return true;
  });
  if (cohortTable.length) {
    cohortTable.push([average, initSum, currSum]);
  }
  return cohortTable;
};

export const createReqBody = (channel, size, plan) => {
  return {
    channel: channel[0] ? channel : '*',
    plan: plan[0] ? plan : '*',
    companySize: size[0] ? size : '*'
  };
};

const dateFormat = date => {
  return [...date.slice(6), '-', ...date.slice(0, 2), '-', '01'].join('');
};

const check = (dates, to, from) => {
  if (new Date(to).getTime() < new Date(dates[0]).getTime()) {
    return true;
  }
  if (new Date(from).getTime() > new Date(dates[dates.length - 1]).getTime()) {
    return true;
  }
  return false;
};
